import {Link} from 'react-router-dom';
import {Navbar} from '@common/ui/navigation/navbar/navbar';
import {Footer} from '@common/ui/footer/footer';
import {useSettings} from '@common/core/settings/use-settings';
import {LaunchOfferBanner} from '@app/landing/launch-offer-banner';
import {PageSeo} from '@app/landing/page-seo';
import {currentYear} from '@app/landing/replace-year';
import {getAllTopics, getGroupLabel, TopicGroup} from './topic-page-data';
import '../landing-page.css';

interface Props {
  group: TopicGroup;
}
export function TopicsHubPage({group}: Props) {
  const {branding, base_url} = useSettings();
  const topics = getAllTopics(group);
  const siteName = branding?.site_name || 'LinkInBio';
  const groupLabel = getGroupLabel(group);
  const pageUrl = `${(base_url || '').replace(/\/$/, '')}/${group}`;

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PageSeo
        title={`Free Link in Bio ${groupLabel} ${currentYear()} | LinkInBio`}
        description={`Browse ${siteName} guides for every ${groupLabel.toLowerCase()} — feature recommendations, tips, and FAQs.`}
        url={pageUrl}
      />
      <Navbar
        color="bg"
        border="border-b"
        className="lp-sticky-nav"
        menuPosition="homepage-navbar"
      />

      <main className="flex-auto">
        <header className="pt-80 md:pt-100 pb-40">
          <div className="landing-container max-w-[900px] text-center">
            <LaunchOfferBanner className="mb-24 inline-block" />
            <span className="section-label">{groupLabel.toUpperCase()}</span>
            <h1 className="alt-heading mb-16">
              {siteName} {groupLabel}
            </h1>
            <p className="text-base text-muted max-w-[700px] mx-auto">
              Browse every {groupLabel.toLowerCase()} guide, with feature
              recommendations and tips built for how you actually work.
            </p>
          </div>
        </header>

        <section className="pb-80 md:pb-100">
          <div className="landing-container max-w-[1000px]">
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-16">
              {topics.map(topic => (
                <Link
                  key={topic.slug}
                  to={`/${group}/${topic.slug}`}
                  className="rounded-xl border px-20 py-16 text-sm font-medium hover:border-primary hover:bg-primary/5 transition-colors"
                >
                  {topic.name}
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer className="mx-14 md:mx-40" />
    </div>
  );
}
